import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { RegisterType } from 'shell/models/register-type';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface RegisterTypeProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const RegisterTypeListComponent = ({
  disabled,
  onChange,
  value,
  required,
  error,
}: RegisterTypeProps): React.ReactElement => {
  const [registerTypes] = useHttpFetch<HttpResponseList<RegisterType>, Array<ItemVM>>(
    `${__CERTIFICATION_API_URL__}/certificazione/tipi-registro`,
    {
      onBootstrap: true,
      initialData: [],
      options: {
        method: 'GET',
        abortable: true,
        errorCatching: false,
        loading: false,
      },
      transformer: (response) => {
        return response.data.payload.list.map((item) => ({
          id: item.key.codice,
          value: item.descrizione,
        }));
      },
    }
  );

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="register-type-label">
        {required ? 'Tipologia di registro *' : 'Tipologia di registro'}
      </InputLabel>
      <PmiSelect
        labelId="register-type-label"
        id="register-type"
        name="register-type"
        value={value}
        label={required ? 'Tipologia di registro *' : 'Tipologia di registro'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(registerTypes.data as Array<ItemVM>)?.map((type: ItemVM) => (
          <MenuItem key={`${type.id}-register-type`} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

RegisterTypeListComponent.displayName = 'List register type component';

const RegisterTypeList = memo(RegisterTypeListComponent);

export default RegisterTypeList as typeof RegisterTypeListComponent;
